(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-pdp"] && !Shopify.designMode) return;
  try {
    
  // Some phone browsers (e.g. Instagram's in-app browser) ignore the autoplay attribute:
  // start muted videos when they scroll into view, and again on the first tap.
  (function () {
    function videos() { return document.querySelectorAll('video[data-ss-autoplay]'); }
    function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function inView(v) { var r = v.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; }
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && e.target.paused) play(e.target); });
    }, { threshold: 0.25 }) : null;
    function boot(root) {
      (root || document).querySelectorAll('video[data-ss-autoplay]').forEach(function (v) {
        v.muted = true; v.playsInline = true;
        if (io) io.observe(v); else play(v);
      });
    }
    function kick() { videos().forEach(function (v) { if (v.paused && inView(v)) play(v); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();
    ['touchend', 'click', 'keydown'].forEach(function (ev) { document.addEventListener(ev, kick, { passive: true }); });
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  })();

  (function () {
    function init(root) {
      var track = root.querySelector('[data-ss-track]');
      var thumbs = root.querySelectorAll('[data-ss-thumb]');
      function go(i) {
        var slides = track.children; if (!slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      function current() { return Math.round(track.scrollLeft / track.clientWidth); }
      if (track) {
        track.addEventListener('scroll', function () {
          var c = current();
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === c); });
        }, { passive: true });
        thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.ssThumb); }); });
        var prev = root.querySelector('[data-ss-prev]'), next = root.querySelector('[data-ss-next]');
        if (prev) prev.addEventListener('click', function () { go(current() - 1); });
        if (next) next.addEventListener('click', function () { go(current() + 1); });
      }

      var qty = root.querySelector('[data-ss-qty]');
      root.querySelectorAll('.ss-pdp__bundle').forEach(function (b) {
        b.addEventListener('click', function () {
          root.querySelectorAll('.ss-pdp__bundle').forEach(function (o) { o.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          var r = b.querySelector('input'); r.checked = true; qty.value = r.value;
          var stickPrice = document.querySelector('[data-ss-stick-price]');
          var bp = b.querySelector('.ss-pdp__bprice strong');
          if (stickPrice && bp) stickPrice.textContent = bp.textContent;
        });
      });

      // No cart: a cart permalink replaces the cart with this quantity and opens checkout directly.
      var form = root.querySelector('[data-ss-form]');
      function goCheckout(e) {
        if (e) e.preventDefault();
        window.location.href = form.getAttribute('data-ss-permalink') + qty.value;
      }
      form.addEventListener('submit', goCheckout);

      var stick = document.querySelector('[data-ss-stick]');
      var buy = root.querySelector('[data-ss-buy]');
      if (stick && buy && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          stick.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
        }).observe(buy);
        stick.querySelector('[data-ss-stick-btn]').addEventListener('click', goCheckout);
      }
    }
    document.querySelectorAll('[data-ss-pdp]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-ss-pdp]').forEach(init); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-video-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var videos = root.querySelectorAll('.ss-vw__video');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.play().catch(function () {}); } else { e.target.pause(); }
          });
        }, { threshold: 0.5 });
        videos.forEach(function (v) { io.observe(v); });
      }
      root.querySelectorAll('.ss-vw__sound').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = btn.parentElement.querySelector('video');
          var turnOn = v.muted;
          root.querySelectorAll('.ss-vw__video').forEach(function (o) { o.muted = true; });
          root.querySelectorAll('.ss-vw__sound').forEach(function (o) { o.classList.remove('is-on'); });
          if (turnOn) { v.muted = false; v.currentTime = 0; v.play().catch(function () {}); btn.classList.add('is-on'); }
        });
      });
    }
    document.querySelectorAll('.ss-vw').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.ss-vw').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
